// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Bka-z","beautyGrouping":"Cka-z","beautySwatches":"Dka-z","swatches":"Eka-z"};